module.exports = __webpack_public_path__ + "media/img/hartmannbund-logo-small-a12383ce4e9bde2d1628f11e2ca0fb4a.svg";